import React from "react";
import { connect } from "react-redux";
import cookie from 'react-cookies';
import { Modal } from "react-bootstrap";

import * as ROUTES from "../../constant/routes"

import { getLoggedProfile } from "../../actions/sessionAct";

import { commonErr } from "../common/errors";
import { quickSignup } from "../../model/profile";
import { MessageBox } from "../common/messagebox";
import { LoadingOverlay } from "../common/loading";

import { CustomInputLabelOutside, CustomSelect } from "../components/input";
import Login3rd from "./login3rd";

import { IcCloseRed, IcPassword, IcEye, Checked } from "../common/svg";

const MsgConfirm = ({show, onHide}) => {
    return (
            <Modal
                show={show}
                onHide={onHide}
                dialogClassName="modal-s modal-dialog modal-confirm"
                >
                <Modal.Header closeButton={true} closeLabel={""}>
                    <h5>Đăng ký tài khoản thành công</h5>
                    <div className="wrap-svg">
                        <Checked />
                    </div>
                </Modal.Header>
                <Modal.Body>
                  	<div className="modal-confirm-register-body">
						<p className="font-14">Hệ thông sẽ tự động đăng nhập. Hãy cập nhật tài khoản của bạn hoặc đóng thông báo để tiếp tực sử dụng dịch vụ của Mioto</p>
						<div className="wrap-btn has-2-btn">
						<a className="btn btn--m btn-primary" href="/account">Cập nhật tài khoản</a>
						<a className="btn btn-link" onClick={onHide}>Đóng</a></div>
                    </div>
                </Modal.Body>
            </Modal>
    )
}


class SignUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ip_name: "",
            ip_phone: "",
            ip_password: "",
            ip_password_confirm: "",
            ip_sharecode: "",
            err: commonErr.INNIT,
            errMsg: "",
            ipType: 'password', 
            ipTypeCf: 'password',
			msgSuccess: false
        }
    }



    handleInputChange = (event) => {
        this.setState({
            [event.target.name]: event.target.value
        });
    }

    hideMessageBox = () => {
        this.setState({
            errMsg: ""
        });
    }

    getLoggedProfile = () => {
        this.props.dispatch(getLoggedProfile());
    }

	onSignUpBtnClick = (event) => {
			
        const name = this.state.ip_name;
        const phone = this.state.ip_phone;
        const password = this.state.ip_password;
        const passwordConfirm = this.state.ip_password_confirm;
        const shareCodeUid = this.state.ip_sharecode;

   
        if (name !== "" && phone !== "" && password !== "") {
            if (password !== passwordConfirm) {
                this.setState({
                    err: commonErr.FAIL,
                    errMsg: "Mật khẩu không khớp"
                });
            } else {
                this.setState({ err: commonErr.LOADING, isSignUp: false, msgSuccess: true  });

                //GA
                const utmSrc = cookie.load("_utm_src") || "web_directly";
                const utmExt = cookie.load("_utm_ext") || "no_label";
                // window.ga('send', 'event', utmSrc, "ACCOUNT_REGISTER", utmExt);

                window.gtag('event', "ACCOUNT_REGISTER", {
                    event_category: utmSrc,
                    event_label: utmExt,
                    campaign: {source: utmSrc}
                });

                window.fbq('track', "ACCOUNT_REGISTER");
				
               	 quickSignup(phone, name, password, shareCodeUid).then(resp => {
				
                    this.setState({ err: resp.data.error, errMsg: resp.data.errorMessage, isSignUp: false, msgSuccess: true });
				
                    if (resp.data.error >= commonErr.SUCCESS) {
                        this.getLoggedProfile();
                    }
			    });
						
            }
        } else {
            this.setState({
                err: commonErr.FAIL,
                errMsg: "Thông tin không hợp lệ"
            });
        }
    }

    readPolicyChange = (event) => {
        this.setState({
            readPolicy: event.target.checked
        });
    }

    showMsgConfirm = () => {
        this.setState({
            msgSuccess: true
        });
    }

    hideMsgConfirm = () => {
        this.setState({
            msgSuccess: false
        });
    }

  	toggleInput = (name, str) => {  
      this.setState({
        [`${name}`]: str
      })
	}

	renderPw = (name, type) => {
		const ipType = type === 'password' ? 'text' : 'password';
    
		return <div className="wrap-svg" onClick={() => this.toggleInput(name, ipType)}>
			{type === 'password' ? <IcPassword /> : <IcEye />}
		</div>
	}

	hideModal = () => {
		this.props.hideModal();
		this.setState({
			ipType: 'password',
			ipTypeCf: 'password'
		})
	}


    render() {
        var content;
        const { inputType, ipType, ipTypeCf, msgSuccess, isSignUp } = this.state;
		
        const icPw = this.renderPw('ipType', ipType)
        const icPwC = this.renderPw('ipTypeCf', ipTypeCf)

        if (this.state.err === commonErr.SUCCESS) {
            content = <MsgConfirm show={msgSuccess} onHide={this.hideMsgConfirm} />
        } else {
            content = <div className="modal-input-body">
                            <div className="line-form">
                                <CustomInputLabelOutside type={"text"} name={"ip_phone"} label="Số điện thoại" onChange={this.handleInputChange} />
                            </div>
                            <div className="line-form">
                                <CustomInputLabelOutside type={"text"} name={"ip_name"} label="Tên hiển thị" onChange={this.handleInputChange} />
                            </div>
                            <div className="line-form">
                                <CustomInputLabelOutside type={ipType} name={"ip_password"} label="Mật khẩu" onChange={this.handleInputChange} icRight={icPw} />
                            </div>
                            <div className="line-form">
                                <CustomInputLabelOutside type={ipTypeCf} name={"ip_password_confirm"} label="Mật khẩu" onChange={this.handleInputChange} icRight={icPwC} />
                            </div>
                            <div className="line-form">
                                <CustomInputLabelOutside type={"text"} name={"ip_sharecode"} label="Mã giới thiệu (nếu có)" onChange={this.handleInputChange} />
                            </div>

                            <div className="wrap-test">
                                <div className="custom-checkbox-selected">
                                    <input type="checkbox" id='cbPolicy' name='cbPolicy' onChange={this.readPolicyChange} />
                                    <label htmlFor='cbPolicy'>Tôi đồng ý với chính sách của Mioto. <a className="text-primary fontWeight-5" href={ROUTES.PRIVACY}>Chi tiết</a></label>
                                </div>
    
                            </div>
                            <div className="wrap-btn btn-register">
                                <a disabled={!this.state.readPolicy} onClick={this.onSignUpBtnClick} className="btn btn--m btn-primary">Đăng ký</a>
                            </div>
                            
                            <Login3rd login={true} />
                            {this.state.errMsg && this.state.errMsg !== "" && <MessageBox error={this.state.err} message={this.state.errMsg} show={this.state.errMsg && this.state.errMsg !== ""} hideModal={this.hideMessageBox} />}
                        </div>
        }

        return 	<Modal
                show={this.props.show}
                onHide={this.hideModal}
                dialogClassName="modal-s modal-dialog modal-input"
                >
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>Đăng ký</h5>
					</Modal.Header>
					<Modal.Body>
						<div className="modal-input-body">
							{content}
						</div>
					</Modal.Body>
            </Modal>
    }
}

function mapState(state) {
    return {
        session: state.session
    }
}

SignUp = connect(mapState)(SignUp);

export default SignUp;


